import { render } from "./MediaCard.vue?vue&type=template&id=5c96f820"
import script from "./MediaCard.vue?vue&type=script&lang=js"
export * from "./MediaCard.vue?vue&type=script&lang=js"

import "./MediaCard.vue?vue&type=style&index=0&id=5c96f820&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__